/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FxIdDomainEntitiesDocumentsGeoTarget {
    RussianPI = 0,
    GRPD = 1,
    CCPA = 2,
    All = 999,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainEntitiesDocumentsGeoTarget(value: any): boolean {
    for (const key in FxIdDomainEntitiesDocumentsGeoTarget) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesDocumentsGeoTarget, key)) {
            if (FxIdDomainEntitiesDocumentsGeoTarget[key as keyof typeof FxIdDomainEntitiesDocumentsGeoTarget] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainEntitiesDocumentsGeoTargetFromJSON(json: any): FxIdDomainEntitiesDocumentsGeoTarget {
    return FxIdDomainEntitiesDocumentsGeoTargetFromJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsGeoTargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesDocumentsGeoTarget {
    return json as FxIdDomainEntitiesDocumentsGeoTarget;
}

export function FxIdDomainEntitiesDocumentsGeoTargetToJSON(value?: FxIdDomainEntitiesDocumentsGeoTarget | null): any {
    return value as any;
}

export function FxIdDomainEntitiesDocumentsGeoTargetToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesDocumentsGeoTarget {
    return value as FxIdDomainEntitiesDocumentsGeoTarget;
}

